// extracted by mini-css-extract-plugin
export default {"control":"PaymentSortFilter_control__9eEVE","text":"PaymentSortFilter_text__kQT4q"};